export const navItems = [
  { id: 'home', label: 'HOME', icon: '🏠' },
  { id: 'about', label: 'ABOUT', icon: '👤' },
  { id: 'skills', label: 'SKILLS', icon: '💪' },
  { id: 'projects', label: 'QUESTS', icon: '⚔️' },
  { id: 'contact', label: 'CONTACT', icon: '📮' }
];